import { Controller } from '@hotwired/stimulus';

/**
 * 他の管理者が組合員情報を編集中のとき、画面内のフォームを操作できなくするStimulusコントローラ（要件4-2）
 * 既存のフォームに手を入れずに閲覧のみにするため、表示中のバナーから画面内のフォームへ inert を付ける。
 * 保存はサーバー側でも拒否するため、ここでは操作の防止と見た目だけを扱う。
 * @extends Controller
 */
export default class extends Controller {
  connect() {
    document.querySelectorAll('main form').forEach((form) => {
      if (this.element.contains(form)) return;

      form.inert = true;
      form.style.opacity = '0.6';
    });
  }
}
